import $ from 'jquery';

import twitterFetcher from 'twitter-fetcher';

export default class TwitterFeed {
  constructor({ el }) {
    this.$el = $(el);
    this.initializedClass = 'twitter-initialized';
    this._validate();
  }

  _validate() {
    this.$tweetContainer = $('[data-twitter-tweets]', this.$el);
    const username = $('[data-twitter-username]', this.$el).attr('data-twitter-username');
    const showRetweets = $('[data-twitter-show-retweets]', this.$el).length;
    const showImages = $('[data-twitter-show-images]', this.$el).length;
    const isInitialized = this.$el.hasClass(this.initializedClass);

    this._fetchTweets(username, showRetweets, showImages, isInitialized);
  }

  _fetchTweets(username, showRetweets, showImages, isInitialized) {
    if (!username.length) {
      this._hasError(false);
      return;
    }
    if (isInitialized) { return; }

    const config = {
      profile: { screenName: username },
      maxTweets: 3,
      enableLinks: true,
      showUser: true,
      showTime: true,
      showRetweet: showRetweets,
      showImages,
      customCallback: tweets => this._renderTweets(tweets),
      showInteraction: false,
      useEmoji: true,
    };

    twitterFetcher.fetch(config);
  }

  _renderTweets(tweets) {
    const $tweetWrapper = $('[data-tweet]');

    if (tweets.length) {
      tweets.forEach((tweet) => {
        $tweetWrapper.append(`<div class='twitter-tweet'>${tweet}</div>`);
        $tweetWrapper.find('.user').remove();
        $tweetWrapper.find('.timePosted').addClass('accent-text').appendTo();
      });
      const tweetEls = $tweetWrapper.find('.twitter-tweet');
      tweetEls.each((i, el) => $(el).find('.timePosted').appendTo(el));
    } else {
      // twitterFetcher changes the view element to window, so we cannot use @$el here
      this.$tweetContainer.remove();

      console.log('No tweets to display. Most probable cause is an incorrectly entered username.');
    }
  }

  _hasError(response) {
    this.$el.toggleClass(this.initializedClass, false);
    this.$tweetContainer.html();

    if (response) { console.log(`Twitter error: ${response.meta.error_message}`); }
  }

  update() {
    this._validate();
  }
}
